/* ==========================================================================
   Design System
   Pagination Styling
   ========================================================================== */
/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
.m-pagination {
  position: relative;
}
.m-pagination__form {
  padding: 0.3125em;
  border-radius: 0.25em;
  background: var(--gray-5);
  color: var(--gray);
  text-align: center;
}
.m-pagination__current-page {
  width: 2.8125em;
  margin-right: 0.625em;
  margin-left: 0.625em;
  font-weight: 500;
  text-align: right;
}
.m-pagination__label {
  display: inline-block;
  margin-right: 0.625em;
  vertical-align: middle;
}
.m-pagination__btn-submit {
  margin: 0;
  vertical-align: middle;
}
.m-pagination__btn-prev, .m-pagination__btn-next {
  min-width: 130px;
  line-height: 22px;
  text-align: center;
}
.m-pagination__btn-prev.a-btn--disabled, .m-pagination__btn-next.a-btn--disabled {
  background-color: var(--gray-5);
  border-color: transparent;
}
.m-pagination__btn-next {
  position: absolute;
  right: 0;
}
@media only all and (max-width: 37.5em) {
  .m-pagination__btn-prev, .m-pagination__btn-next {
    margin-bottom: 0.9375em;
  }
}
@media only all and (min-width: 37.5625em) {
  .m-pagination__btn-prev, .m-pagination__btn-next {
    height: 100%;
  }
  .m-pagination__btn-prev {
    position: absolute;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .m-pagination__btn-next {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
}